import styled from 'styled-components';
import { MENU_BORDER_RADIUS_PX } from '../constants';

export const Root = styled.div`
  border-top-left-radius: ${MENU_BORDER_RADIUS_PX}px;
  border-top-right-radius: ${MENU_BORDER_RADIUS_PX}px;
`;
